module.exports = __webpack_public_path__ + "static/img/prezzta.c2b01495.png";